import API from '@/api/index';

const notification = {
  state: {
    notifications: [],
    news: []
  },

  mutations: {
    SET_NOTIFICATIONS: (state, list) => {
      state.notifications = list;
    },
    SET_NEWS: (state, list) => {
      state.news = list;
    },
    MARK_ALL_AS_READ: (state) => {
      state.notifications.map(a => {
        a.isRead = true;
        return 0;
      });
    }
  },

  actions: {
    getNotifications ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.notification.getNotifications(params).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_NOTIFICATIONS', result.data.data);
            resolve(result.data.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getWarning ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.notification.getWarning(params).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_NOTIFICATIONS', result.data.data);
            resolve(result.data.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getNews ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.notification.getNews(params).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_NEWS', result.data.data);
            resolve(result.data.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    markAllNotificationAsRead ({ commit }) {
      commit('MARK_ALL_AS_READ');
      return new Promise((resolve, reject) => {
        API.notification.markAllNotificationAsRead().then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    deleteNotifications ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.notification.deleteNotifications(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default notification;


// WEBPACK FOOTER //
// ./src/store/modules/notification.js